export const PROCESSING_DATE_AND_TIME = "Processing date and time"
export const PLACE_DURING_BUSINESS_HOUR = "Place during business hour"
export const CURBSIDE_PICKUP_REQUIRED = "To continue, please select curbside pickup."
export const PAYMENT_ERROR_MESSAGE = "Something went wrong. Please try again.";
export const SNAP_ELIGIBLE_ITEMS = "Shop SNAP EBT Eligible Items";

export const ReactQueryKeys = {
  PRODUCTS_FROM_UPC: 'productsFromUpc',
  COUPON_LIST: 'couponList',
  COUPON_DETAILS: 'couponDetails',
  CUSTOMER_DETAILS: 'customerDetails',
  CUSTOMER_ADDRESS_LIST: 'customerAddressList',
}

export const Clients = {
  Redners: "323"
}

export const getPatternPasswordValidationMessage = (minLengh, maxLengh) => `${minLengh} - ${maxLengh} characters long. 1 Capital letter, 1 small letter, 1 Special character, 1 numeric required.`
